import { addToast, addErrorToast } from "@src/utils/toast";

const returnValue = {
  addToast,
  addErrorToast,
};
export const useToast = (): typeof returnValue => {
  return returnValue;
};
